export default __webpack_public_path__ + "static/media/Logo Avast.5161591e.png";